import { createApp } from 'vue'
import App from './App.vue'

if (window.location.pathname === '/healthcheck') {
  // 2. Return a simple OK string and stop Vue from loading
  document.body.innerHTML = 'OK';
} else {
  // 3. Otherwise, load the chat widget normally
  createApp(App).mount('#app')
}